import { useQuery } from "react-query";

import {
  makeSimpleDeleteRequest,
  makeSimpleGetRequest,
  makeSimplePatchRequest,
  makeSimplePostRequest,
} from "lib/axios";
import { skipRetriesOn404 } from "lib/react-query";
import { ORDERBOOK_URL } from "services/constants";

import { ListingNote } from "./types";

const LISTING_NOTES_URL = `${ORDERBOOK_URL}/listing-notes`;

export const getListingNote = async (
  listingId: number,
): Promise<ListingNote | null> => {
  const response = await makeSimpleGetRequest<ListingNote[]>(
    `${LISTING_NOTES_URL}/?filter{listing}=${listingId}`,
  );
  return response[0] || null;
};

export const createListingNote = async (
  listingId: number,
  content: string,
): Promise<ListingNote> => {
  return await makeSimplePostRequest<ListingNote>(
    `${LISTING_NOTES_URL}/`,
    JSON.stringify({ listing: listingId, content }),
    [201],
  );
};

export const updateListingNote = async (
  id: number,
  content: string,
): Promise<ListingNote> => {
  return await makeSimplePatchRequest<ListingNote>(
    `${LISTING_NOTES_URL}/${id}/`,
    JSON.stringify({ content }),
    [200],
  );
};

export const deleteListingNote = async (id: number): Promise<void> => {
  await makeSimpleDeleteRequest(`${LISTING_NOTES_URL}/${id}/`, [204]);
};

export const useListingNote = (listingId: number) =>
  useQuery(
    ["listingNote", listingId],
    async () => await getListingNote(listingId),
    {
      enabled: !!listingId,
      retry: skipRetriesOn404,
    },
  );
